import { useEffect, useState } from 'react';

import { t } from 'i18next';

import styles from './SideBar.module.css';
import AboutCompany from './AboutCompany/AboutCompany';
import RecentJobs from './RecentJobs/RecentJobs';
import { fetchJobsByEmployer, getSimilarJobs } from '../../../../../services/jobService';

function SideBar({ job }) {
    const [recentJob, setRecentJob] = useState([])
    const [similarJobs, setsimilarJobs] = useState([])

    useEffect(() => {
        const MAX_RETRIES = 1000;
        let retryCount = 0;
        const getRecentJob = async () => {
            if (job.employer_id) {
                try {
                    const fetchedJobs = await fetchJobsByEmployer(job.employer_id);
                    const sortedJobs = fetchedJobs?.jobs?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                    setRecentJob(sortedJobs.slice(0, 4));
                } catch (error) {
                    if (error.error === 'out of shared memory' && retryCount < MAX_RETRIES) {
                        retryCount++;
                        console.log(`Retrying... Attempt ${retryCount}`);
                        getRecentJob();
                    }
                }
            }
        }
        if (job.employer_id && job.id) {
            const getData = async () => {
                await getRecentJob()
                await setsimilarJobs(await getSimilarJobs(job.id))
            }
            getData()
        }
    }, [job])
    return (
        <div className={styles.container}>
            <AboutCompany job={job} />
            <RecentJobs title={t('sidebar.recent_jobs_from_this_company')} job={recentJob} />
            <RecentJobs title={t('sidebar.similar_jobs')} job={similarJobs} />
        </div>
    )
}

export default SideBar;